import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { UIHelpers } from '../../../constants/pages/UIHelpers';

const ClientsUIContext = createContext();
const { initialFilter } = UIHelpers();

export function useClientsUIContext () {
    return useContext(ClientsUIContext);
}

export const ClientsUIConsumer = ClientsUIContext.Client;

export function ClientsUIProvider ({ clientsUIEvents, children }) {
    const [isLoading, setIsLoading] = useState(false);
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const initClient = {};

    const value = {
        isLoading,
        setIsLoading,
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        initClient
    };

    return <ClientsUIContext.Provider value={value}>{children}</ClientsUIContext.Provider>;
}
